export default "__VITE_ASSET__DEvQ7k9B__"